function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
import { getHslAnimationFromHsl, rangeColorToHsl } from "tsparticles-engine";
import { updateColor } from "./Utils";
export var ColorUpdater = /*#__PURE__*/function () {
  function ColorUpdater(container) {
    _classCallCheck(this, ColorUpdater);
    this.container = container;
  }
  _createClass(ColorUpdater, [{
    key: "init",
    value: function init(particle) {
      var hslColor = rangeColorToHsl(particle.options.color, particle.id, particle.options.reduceDuplicates);
      if (hslColor) {
        particle.color = getHslAnimationFromHsl(hslColor, particle.options.color.animation, this.container.retina.reduceFactor);
      }
    }
  }, {
    key: "isEnabled",
    value: function isEnabled(particle) {
      var _particle$options$col = particle.options.color.animation,
        hAnimation = _particle$options$col.h,
        sAnimation = _particle$options$col.s,
        lAnimation = _particle$options$col.l,
        color = particle.color;
      return !particle.destroyed && !particle.spawning && ((color === null || color === void 0 ? void 0 : color.h.value) !== undefined && hAnimation.enable || (color === null || color === void 0 ? void 0 : color.s.value) !== undefined && sAnimation.enable || (color === null || color === void 0 ? void 0 : color.l.value) !== undefined && lAnimation.enable);
    }
  }, {
    key: "update",
    value: function update(particle, delta) {
      updateColor(particle, delta);
    }
  }]);
  return ColorUpdater;
}();